module.exports = __webpack_public_path__ + "img/logo-management-raw.b2c51ec0.png";